import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  userChallenges: {},
  userChallengesAreLoaded: false,

  userChallenge: null,
  userChallengeAreLoaded: false,

  error: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.BO_GET_USER_CHALLENGES[REQUEST]:
      return {
        ...state,
        userChallengesAreLoaded: false,
      };

    case ActionTypes.BO_GET_USER_CHALLENGES[SUCCESS]:
      return {
        ...state,
        userChallenges: action.data,
        userChallengesAreLoaded: true,
      };

    case ActionTypes.BO_GET_USER_CHALLENGES[FAILURE]:
      return {
        ...state,
        error: action.error,
        userChallengesAreLoaded: false,
      };

    case ActionTypes.BO_GET_USER_CHALLENGE[REQUEST]:
      return {
        ...state,
        userChallengeAreLoaded: false,
      };

    case ActionTypes.BO_GET_USER_CHALLENGE[SUCCESS]:
      return {
        ...state,
        userChallenge: action.data,
        userChallengeAreLoaded: true,
      };

    case ActionTypes.BO_GET_USER_CHALLENGE[FAILURE]:
      return {
        ...state,
        error: action.error,
        userChallengeAreLoaded: false,
      };

    case ActionTypes.BO_INCREASE_USER_CHALLENGE[REQUEST]:
    case ActionTypes.BO_CLOSE_USER_CHALLENGE[REQUEST]:
      return {
        ...state,
        userChallengesAreLoaded: false,
      };

    case ActionTypes.BO_INCREASE_USER_CHALLENGE[SUCCESS]:
    case ActionTypes.BO_CLOSE_USER_CHALLENGE[SUCCESS]:
      return {
        ...state,
        userChallengesAreLoaded: true,
      };

    case ActionTypes.BO_INCREASE_USER_CHALLENGE[FAILURE]:
    case ActionTypes.BO_CLOSE_USER_CHALLENGE[FAILURE]:
      return {
        ...state,
        error: action.error,
        userChallengesAreLoaded: true,
      };

    default:
      return state;
  }
};

export default reducer;
